/**
 * Cross-section primary rail (left nav): section navigation for real-estate workspace.
 * CL-374A: profile lives in header (EDIT PROFILE); not in this rail.
 * CL-393A-FIX1: My Properties → portfolio list (/real-estate/properties), not legacy /my-property hub.
 */
import { MY_PROPERTIES_LIST_PATH } from "../utils/propertyIntelligenceRoutes";
export const CLIENT_PORTAL_PROFILE_PATH = "/client-portal/account/profile";

export const CLIENT_PORTAL_PRIMARY_NAV = [
  { to: "/client-portal/real-estate", label: "Dashboard", end: true },
  { to: MY_PROPERTIES_LIST_PATH, label: "My Properties", end: true },
  { to: "/client-portal/real-estate/search", label: "Search", end: true },
  { to: "/client-portal/real-estate/transactions", label: "Transactions", end: true },
  { to: "/client-portal/resources", label: "Resources" },
];
